var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmap4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 83,
    viewBox: "0 0 93 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6542 47.7836C17.3189 66.2147 -0.476448 77.6244 0.00976562 79.8673C0.495979 82.1103 19.2638 75.1864 40.0737 76.4542C60.9809 77.6244 83.8329 86.9862 90.6399 81.0376C97.5441 75.0889 88.2088 53.9273 76.7342 34.4235C65.2595 14.8222 51.6456 -3.21883 44.3524 0.486892C37.0592 4.09509 36.0868 29.45 26.6542 47.7836Z",
    fill: "#FF583D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3516 52.584V50.312L52.6316 43.832H56.2796V50.504H58.3436V52.584H56.2796V55H53.3676V52.584H45.3516ZM53.3676 46.248H53.2876L48.5996 50.424V50.504H53.3676V46.248ZM59.6338 52.104H62.9458V55H59.6338V52.104Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap4);
export default __webpack_public_path__ + "static/media/Roadmap4.ddc151a0c30c0037b676c808346da25a.svg";
export { ForwardRef as ReactComponent };